import React from "react";

// AEGIS shield badge logo
export default function Logo({ className = "w-8 h-8" }) {
  return (
    // Header/brand mark: renders above the fold, so it loads eagerly and
    // carries its intrinsic size to reserve layout space.
    <img
      src="/aegis/aegis-logo.webp"
      alt="AEGIS shield"
      width={237}
      height={256}
      loading="eager"
      decoding="async"
      className={`${className} object-contain`}
    />
  );
}
